module.exports = __webpack_public_path__ + "img/w-icon-water.66eaf2f2.png";